// extracted by mini-css-extract-plugin
export var activeFilterButton = "_j6-c";
export var backButton = "_j6-4";
export var backIcon = "_j6-5";
export var chevronShortcut = "_j6-6";
export var container = "_j6-1";
export var editor = "_j6-8";
export var editorWrapper = "_j6-7";
export var prefix = "_j6-2";
export var searchIcon = "_j6-3";
export var suffix = "_j6-9";
export var suffixContent = "_j6-a";
export var suffixText = "_j6-b";
export var wrapper = "_j6-0";